import { AfterViewInit, Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { EventManager } from 'src/app/core';
@Component({
  selector: 'app-add-email',
  templateUrl: './add-email.component.html',
  styleUrls: ['./add-email.component.scss']
})
export class AddEmailComponent implements OnInit, OnChanges {
  editForm = this.fb.group({
    receiver: [''],
  });
  receivers: any[] = [];
  summaryReceivers: any[] = [];
  @Input() data: any;
  @Output() result: EventEmitter<any> = new EventEmitter();
  errors: any = {};
  constructor(
    private fb: FormBuilder,
    public eventManager: EventManager,
  ) {
  }
  ngOnInit() {
  }
  ngAfterViewInit(): void {
  }
  ngOnChanges(changes: SimpleChanges) {
    if (changes.data && changes.data.currentValue) {
      this.updateForm();
    }
  }
  updateForm() {
    this.receivers = this.data || [];
    this.summaryReceivers = this.receivers.slice(0, 10);
  }
  addEmail() {
    const text = this.editForm.value.receiver || '';
    const splits = text.split(',')
    this.receivers = [...splits, ...this.receivers];
    this.summaryReceivers = this.receivers.slice(0, 10);
    this.editForm.patchValue({
      receiver: ''
    })
  }
  cleanEmail() {
    this.receivers = []; 
    this.summaryReceivers = [];
  }
  deleteTag(index) {
    this.receivers.splice(index, 1);
    this.summaryReceivers = this.receivers.slice(0, 10);
  }
  emitData() {
    return this.receivers || [];
  }
}
